import React from "react";
import styles from "./UnorderedListComponent.module.scss";

export const UnorderedListComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const wrappedChildren = React.Children.map(children, (child, index) => {
    return <ul key={index}>{child}</ul>;
  });
  return <li className={styles.List}>{wrappedChildren}</li>;
};
